module.exports = "<div class=\"loader\" [hidden]=\"!spin\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/directives/spinner/spinner.component.html
// module id = 74
// module chunks = 3